import BaseListItemIcon from '@material-ui/core/ListItemIcon'

const ListItemIcon = BaseListItemIcon

export default ListItemIcon
